import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";

import { useAppParams } from "../../router";
import {
  getDefaultProfileId,
  getVisibleProfiles,
} from "../../store/profiles/profiles.selectors";
import { GLOBAL_URL_FILTER_ID } from "../urlFilters/urlFilters.constants";
import { SettingsContent } from "./SettingsContent";

interface SettingsProfileRouteGuardProps {
  isUrlFilters?: boolean;
}

export const SettingsProfileRouteGuard = ({
  isUrlFilters,
}: SettingsProfileRouteGuardProps) => {
  const { profileId } = useAppParams();

  const profiles = useSelector(getVisibleProfiles, _.isEqual);
  const defaultProfileId = useSelector(getDefaultProfileId);

  const existingProfile =
    _.find(profiles, { id: profileId }) ||
    (isUrlFilters && profileId === GLOBAL_URL_FILTER_ID);

  return existingProfile ? (
    <SettingsContent>
      <Outlet />
    </SettingsContent>
  ) : (
    <Navigate to={defaultProfileId} />
  );
};
